import news from './NewsReducer';

export default news;
